export default ({ redirect }) => {
  redirect('https://nozzle.ai/pricing')
}
